import Vue from "vue"
import moment from "moment";
import api from '@/api';
import { format } from "silly-datetime";
import sysInit from './sysInit'
const questioner_logo = require('@/assets/img/user_logo.png')
const AI_VOICEBOT_LOGO = require('@/assets/img/ai_voicebot.png')

// Dashboard用の簡易ユーティリティ（utils/utils.jsが存在しない場合の代替）
let vueUtils = {
  computeFullName: (lastname, firstname) => {
    return (lastname || '') + (firstname || '');
  },
  asteriskHeaderArray2Json: (raw) => {
    try {
      return JSON.parse(raw);
    } catch(e) {
      return { tnum: '', relatedIssueId: '' };
    }
  }
};
const getDefaultMonitorInfo = () => ({
  selectedLine:'',
  operatorName:'',
  operatorLogo:'',
  operatorNum:'',
  operatorEmail:''
})

// utils/utils.jsが存在する場合はそれを使用
try {
  const utils = require('@/utils/utils.js');
  if (utils && utils.default) {
    vueUtils = utils.default;
  }
} catch(e) {
  console.log('utils/utils.js not found, using fallback');
}

const state = {
  selectedId: '',
  showPhone: false,
  lineList:[],
  currentCallerNum:'',
  buddiesList: [],
  registerStatus: false,
  callList:[],
  waitingList:[],
  inCallList:[],
  CALL_STATUS_END:3,
  CALL_STATUS_WAITING:1,
  CALL_STATUS_INCALL:2,
  LONG_TIME_WAITING:30, // SECONDS
  selectedLine:'',
  redmineIssueId:'',
  piGetList: [],
  onCallInfo: {},
  CALL_START_AUDIO_TIME:3000, // millisecond
  Tnumber: '',
  showStopMonitoringConfirmDialog: false,
  stopMonitoring: false,
  stopMonitoringTrigger: '',
  lineNumber: '',
  tNumber: '',
  autoStartMonitoringCall: false,
  monitorInfo:getDefaultMonitorInfo(),
}

function getTransferNum(item){
  if(item.incomingInviteRequest && item.incomingInviteRequest.message.headers.Tnumber && item.incomingInviteRequest.message.headers.Tnumber.length && item.incomingInviteRequest.message.headers.Tnumber[0].raw) {
    return vueUtils.asteriskHeaderArray2Json(item.incomingInviteRequest.message.headers.Tnumber[0].raw).tnum
  }else{
    return ''
  }
}

function updateCurrentCallerInfo(){
  let userInfo = state.callList.find(item => item.telnum == state.currentCallerNum && !item.refreshCustomerInfo)
  if(userInfo){
    // DashboardではsysInitがないため、この処理はスキップ
    // 必要に応じて後で追加
  }
}

function checkIfSupportCall(line, isTransfer = false){
  return line.length > 5 || (line.length == 5 && line[0] ==='9') || isTransfer
}

function toPercent(point) {
  var str = Number(point * 100).toFixed(0)
  str = parseInt(str);
  return str;
}

function setCallListBystatus(){
  for(let oneLine of state.lineList ){
    let existsLine = state.callList.find(item => item.telnum == oneLine.LineNumber)
    if(existsLine){
      existsLine.startTime = oneLine.SipSession.data.callTime
      existsLine.time = oneLine.SipSession.data.callTime ? formatTime(oneLine.SipSession.data.callTime):''
      existsLine.isWaiting =(oneLine.SipSession.data && oneLine.SipSession.data.started) ? false : true
      existsLine.isOnHold = oneLine.SipSession.isOnHold;
    }else{
      let lineObj = {
        is_outbound: oneLine.SipSession.data.calldirection == "inbound" ? '0' : '1',
        telnum: oneLine.LineNumber,
        isWaiting: (oneLine.SipSession.data && oneLine.SipSession.data.started) ? false : true,
        refreshEmpathy: true,
        refreshCustomerInfo:true,
        customer_name:"ゲスト",
        logo_url:null,
        current:false,
        heart_change_distance: null,
        similarity:null,
        startTime :oneLine.SipSession.data.callTime,
        time: oneLine.SipSession.data.callTime ? formatTime(oneLine.SipSession.data.callTime):'',
        firstname:"",
        lastname:'ゲスト',
        address:'',
        email:'',
        Tnumber: getTransferNum(oneLine.SipSession),
        isOnHold: oneLine.SipSession.isOnHold
      }
      state.callList.push(lineObj)
    }
  }
  refreshCallList()
  sortCallList()
  state.waitingList = state.callList.filter(item => item.isWaiting && checkIfSupportCall(item.Tnumber?item.Tnumber:item.telnum) )
  state.inCallList = state.callList.filter(item => !item.isWaiting && checkIfSupportCall(item.Tnumber?item.Tnumber:item.telnum))
}

function sortCallList(){
  // DashboardではsysInitがないため、デフォルトで時間順にソート
  state.callList = _.sortBy( state.callList, function(o) { return o.startTime; }).reverse();
}

function formatTime(time){
  let timeArr = time.split(':')
  let minutes = Number(timeArr[0]) > 0 ?  timeArr[0] + '分' :''
  let seconds = timeArr[1] + '秒'
  return minutes + seconds
}

function refreshCallList(){
  for(let i = 0; i < state.callList.length;i++) {
    let oneCall = state.callList[i]
    let exitsLine = state.lineList.find(item => item.LineNumber == oneCall.telnum)
    if(exitsLine){
      if(oneCall.refreshEmpathy && !state.piGetList.includes(oneCall.Tnumber ? oneCall.Tnumber : oneCall.telnum)){
        getEmpathyMatchingInfo(oneCall.Tnumber ? oneCall.Tnumber : oneCall.telnum,refreshEmpathy)
        state.piGetList.push(oneCall.telnum)
      }
      if(oneCall.refreshCustomerInfo || (oneCall.Tnumber && !oneCall.hasInfo)){
        getCustomerInfo(oneCall.Tnumber ? oneCall.Tnumber : oneCall.telnum,refreshCustomerInfo)
        oneCall.hasInfo = true
        oneCall.refreshCustomerInfo = false;
      }
    }else{
      state.callList.splice(i,1)
    }
  }
}

function refreshCustomerInfo(obj){
  for(let oneCall of state.callList){
    if (oneCall.telnum == obj.telnum || oneCall.Tnumber == obj.telnum){
      oneCall.customer_name = obj.customer_name
      oneCall.firstname = obj.firstname
      oneCall.lastname = obj.lastname
      oneCall.email = obj.email
      oneCall.address = obj.address
      oneCall.logo_url = obj.logo_url && obj.logo_url != '' ? obj.logo_url : questioner_logo
      oneCall.refreshCustomerInfo = false
      if(!oneCall.isWaiting){
        updateCurrentCallerInfo()
      }
      break
    }
  }
}

function refreshEmpathy(obj){
  for(let oneCall of state.callList){
    if (oneCall.telnum == obj.telnum || oneCall.Tnumber == obj.telnum){
      oneCall.heart_change_distance = obj.heart_change_distance
      oneCall.similarity = obj.similarity
      oneCall.refreshEmpathy = false
      break
    }
  }
}

function getCustomerInfo(telnum,callback){
  console.log('getCustomerInfo.....')
  let customerInfo={
    telnum,
    customer_name:'ゲスト',
    logo_url:null,
    firstname:"",
    lastname:'ゲスト',
    address:'',  
    email:'' 
  }  
  try{
    // ==========================================
    // 修正日時: 2026-01-23
    // 修正内容: モニタリング（555プレフィックス）の場合、555を削除してFrom numberだけで検索
    //           - モニタリング通話では555+From numberで発信しているが、
    //             ユーザー情報検索はFrom numberだけで行う必要がある
    // ==========================================
    let searchPhoneNum = telnum;
    if (telnum && telnum.startsWith('555')) {
      // 555プレフィックスを削除してFrom numberのみを取得
      searchPhoneNum = telnum.substring(3);
    }
    
    let params = {
      phonenum : searchPhoneNum
    }
    let type = searchPhoneNum.length > 5 || (searchPhoneNum.length == 5 && searchPhoneNum.startsWith('9') )? 'external': 'internal'
    console.log('searchPhoneNum (555 removed if monitoring):', searchPhoneNum)
    api.getUserInfoByType(params,type).then((res)=>{
      if(res.data != 'fail'){
        if(res.data.data[0]){
          let userInfo = res.data.data[0]
          customerInfo.lastname = userInfo.lastname ? userInfo.lastname : 'ゲスト'
          customerInfo.firstname = userInfo.firstname ? userInfo.firstname : ''
          customerInfo.customer_name = vueUtils.computeFullName(customerInfo.lastname, customerInfo.firstname)
          customerInfo.logo_url = userInfo.logo_url
          customerInfo.address = userInfo.current_address || ''
          customerInfo.email = type == 'external'? (userInfo.mail || '' ):(userInfo.address || '')
        }else{
          customerInfo.customer_name = 'ゲスト'
        }
      }
      callback(customerInfo)
    },(err)=>{
      callback(customerInfo)
      console.log(err);
    })
  }catch(err){
    callback(customerInfo)
    console.log(err);
  }
}

function getEmpathyMatchingInfo(telnum,callback){
  console.log('getEmpathyMatchingInfo.....')
  // DashboardではsysInitがないため、デフォルト値を設定
  let temp_params = {
    user_phoneNum:telnum,
    login_email: sessionStorage.getItem('login_id') || '',
    token: sessionStorage.getItem('empathyMatChingToken') || '',
    modeName: sessionStorage.getItem('ws_mode') || '',
    chatStatus:"",
  }
  let temp_heart_change_distance = null;
  let temp_similarity = null;
  try{
    api.getEmpathyMatchingInfo(temp_params).then((res)=>{
        if(res.data != "fail" && res.data.data.empathy50){
          if(res.data.data.empathy50<0.3){
            let temp_similarity = 0.3*(0.7+res.data.data.empathy50);
            temp_heart_change_distance = (1- temp_similarity)*50;
          }else{
            temp_heart_change_distance = (1- res.data.data.empathy50)*50;
          }
          temp_similarity = toPercent(res.data.data.empathy50) + "%";
          callback({telnum:telnum,heart_change_distance:temp_heart_change_distance,similarity:temp_similarity})
        }else{
          temp_similarity = '--%';
          callback({telnum:telnum,heart_change_distance:temp_heart_change_distance,similarity:temp_similarity})
          console.log("fail")
        }
        state.piGetList = state.piGetList.filter(d => d !== telnum)
      }),(err)=>{
        callback({telnum:telnum,heart_change_distance:temp_heart_change_distance,similarity:temp_similarity})
        console.log("pi error", err);
      }
    }catch(err){
      callback({telnum:telnum,heart_change_distance:temp_heart_change_distance,similarity:temp_similarity})
      console.log(err);
    }
}

function getLatestAITicketByPhone(phoneNum){
  return new Promise((resolve, reject) => {
    // DashboardではgetUC1IssueAllTextがない可能性があるため、エラーハンドリング
    try {
      if (api.getUC1IssueAllText) {
        api.getUC1IssueAllText({userId: phoneNum}).then((res)=>{
          return resolve({ data: res.data });
        }).catch(err => {
          return reject({ code: -1, err: err })
        })
      } else {
        return reject({ code: -1, err: 'API not available' })
      }
    } catch(e) {
      return reject({ code: -1, err: e })
    }
  })
}

async function callAnswered(callInfo,callback){
  try{
    let lineNum = getTransferNum(callInfo)? getTransferNum(callInfo):callInfo.data.line
    let userInfo = state.callList.find(item => item.telnum == callInfo.data.line)
    let isOutBound = callInfo.data.calldirection !== "inbound"
    let callStart = moment(callInfo.data.callstart.replace(" UTC", "Z")).utcOffset(0).valueOf();
    let timeBetween = moment().utcOffset(0).valueOf() - callStart;

    // 日
    let days = Math.floor(timeBetween / (24 * 3600 * 1000));
    // 時間
    let hoursRound =  timeBetween % (24 * 3600 * 1000);
    let hours = Math.floor(hoursRound / (3600 * 1000)) + days * 24;
    // 分
    let minutesRound = hoursRound % (3600 * 1000);
    let minutes = Math.floor(minutesRound / (60 * 1000));
    // 秒
    let secondsRound = minutesRound % (60 * 1000);
    let seconds = Math.floor(secondsRound / (1000));
    // マイナスの場合、０としてセット
    let waitedTimeStr = "00:00:00";
    if (hours >= 0 && minutes >= 0 && seconds >= 0){
      waitedTimeStr = [String(hours).padStart(2, '0') , String(minutes).padStart(2, '0'), String(seconds).padStart(2, '0')].join(":");
    }

    let relatedIssueId;
    let conversation_uuid;
    let isTransfered = false
    if(callInfo.incomingInviteRequest
        && callInfo.incomingInviteRequest.message
        && callInfo.incomingInviteRequest.message.headers
      ){
        if(callInfo.incomingInviteRequest.message.headers["Issue-Id"] && callInfo.incomingInviteRequest.message.headers["Issue-Id"][0].raw){ 
          relatedIssueId = callInfo.incomingInviteRequest.message.headers["Issue-Id"][0].raw
        }
        if(callInfo.incomingInviteRequest.message.headers.Tnumber && callInfo.incomingInviteRequest.message.headers.Tnumber.length && callInfo.incomingInviteRequest.message.headers.Tnumber[0].raw){ // 転送前のissueid
          relatedIssueId = vueUtils.asteriskHeaderArray2Json(callInfo.incomingInviteRequest.message.headers.Tnumber[0].raw).relatedIssueId
          isTransfered = true
          console.log('Tnumber relatedIssueId', relatedIssueId);
        }
      conversation_uuid = !isOutBound && callInfo.incomingInviteRequest.message.headers.Uniqueid  ?  callInfo.incomingInviteRequest.message.headers.Uniqueid[0].raw : null
    }

    // TODO: 将来从header中取得，暂定方案，取不到关联票号的时候根据电话号码查询
    if(!relatedIssueId){
      try{
        let latestAITicketByPhoneRes = await getLatestAITicketByPhone(lineNum);
        relatedIssueId = latestAITicketByPhoneRes.data.data.chatbotIssueId;
      }catch{
        console.log('......relatedIssueId error')
      }
    } 
    
    // DashboardではsysInitがないため、tel_numをsessionStorageから取得
    // let tel_num = sessionStorage.getItem('tel_num') || '';
    let tel_num = sysInit.state.tel_num  || '';
    
    let params ={
			from: isOutBound ? tel_num : lineNum,
			to: isOutBound ? lineNum : tel_num,
			isOutBound: isOutBound,
			firstname: userInfo ? userInfo.firstname : '',
			lastname: userInfo ? userInfo.lastname : 'ゲスト',
      answerTime:callInfo.data.startTime,
      waitedTime: waitedTimeStr,
      relatedIssueId: relatedIssueId ? relatedIssueId : "",
      logo_url: userInfo ? userInfo.logo_url : null,
      agentStartTime:moment.utc(callInfo.data.callstart.replace(" UTC", "")).format(),
      conversation_uuid: conversation_uuid,
      isTransfered:isTransfered
		};
    if(state.Tnumber){
      params.from = state.Tnumber
    }
    console.log('getTransferNum(callInfo)....',params)
    api.callAnswered(params).then((res)=>{
      if(res.data != 'fail'){
        if(res.data.data.issueId){
          callback(res.data.data.issueId)
        }else{
          // ==========================================
          // 修正日時: 2026-01-23
          // 修正内容: ボイスボット・モニタリング通話のissueIdエラー対応
          //           - モニタリング通話（555プレフィックス）やボイスボット通話では
          //             issueIdが返ってこないことが正常（電話番号ベースで管理）
          //           - 通常のオペレーター通話でissueIdがない場合のみエラーを出力
          //           - 将来の拡張: ボイスボット通話でもRedmine issueを作成し、
          //             issueIdで管理する場合は、バックエンドの/call/answered APIを
          //             修正してissueIdを返すようにする必要がある
          // ==========================================
          // モニタリング通話（555で始まる）またはボイスボット通話の判定
          const isMonitoringCall = lineNum && lineNum.startsWith('555');
          // ボイスボットの判定（queueNum === '8899'や電話番号ベースの判定が必要な場合は
          // バックエンドのレスポンスにisVoiceBotフラグを追加することを検討）
          // 暫定: モニタリング通話の場合はissueIdがなくても正常とみなす
          if (isMonitoringCall) {
            // モニタリング通話はissueIdなしが正常（電話番号ベースで管理）
            console.log('Monitoring call: issueId not required (managed by phone number)');
            callback(null);
          } else {
            // 通常のオペレーター通話でissueIdがない場合はエラー
            console.error('no issue id');
            callback(null);
          }
        }
      }
    },(err)=>{
      console.log(err);
    })
  }catch(err){
    console.log(err);
  }
}

function endCall(callInfo,callback){
  try{
    let lineNum = callInfo.data.line
    let isOutBound = callInfo.data.calldirection !== "inbound"
    console.log('callInfo.data.callstart', callInfo.data.callstart, moment.utc(callInfo.data.callstart.replace(" UTC", "")).format())
    
    // DashboardではsysInitがないため、tel_numをsessionStorageから取得
    // let tel_num = sessionStorage.getItem('tel_num') || '';
    let tel_num = sysInit.state.tel_num || ''
    
    let params ={
			from: isOutBound ? tel_num : lineNum,
			to: isOutBound ? lineNum : tel_num,
			isOutBound: isOutBound,
      issueId:state.redmineIssueId,
      answerTime:callInfo.data.startTime, // UTC time
      agentStartTime:moment.utc(callInfo.data.callstart.replace(" UTC", "")).format()
		}
    if(state.Tnumber) {
      params.from = state.Tnumber
    }
    api.callEnd(params).then((res)=>{
      if(res.data != 'fail'){
        if(res.data.data.record_info){
          callback(res.data.data.record_info)
        }else{
          console.error('end call error')
        }
      }
    },(err)=>{
      console.log(err);
    })
  }catch(err){
    console.log(err);
  }
}

function getOnCallInfo(telNum, callback){
  console.log(telNum);
  api.getOnCallInfo(telNum).then((res) => {
    console.log(res);
    callback(res.data.userInfo ? res.data.userInfo : {})
  }).catch((err) => {
    console.error('end call error')
  });
}

const getters = {
  showPhone: state => state.showPhone,
  buddiesList: state => state.buddiesList
}

const actions = {
  setShowPhone: (context, status) => {
    context.commit('setShowPhone', status)
  },
  terminateTheCall(context,item){
    console.log('entering terminateTheCall',item)
    state.selectedLine = state.selectedLine == item.data.line ? '':state.selectedLine
    // DashboardではsysInitがないため、簡略化
    if (state.currentCallerNum == '') {
      if (state.waitingList.length == 0 || (state.waitingList.length == 1 && state.waitingList[0].telnum == item.data.line)) {
        // 状態管理は必要に応じて追加
      }
    } else if (state.currentCallerNum != item.data.line || !checkIfSupportCall(item.data.line, state.Tnumber)) {
      if (state.inCallList.length == 1 && state.waitingList.length == 0) {
        // 状態管理は必要に応じて追加
      }
    } else {
      localStorage.setItem('callType', '3');
      if(state.redmineIssueId != ''){
        endCall(item,(endCallRecord)=>{
          state.redmineIssueId = ''
          console.log('endCallRecord........',endCallRecord)
        })
      }
    }
  },
  receiveCall(context,item){
    console.log('receiveCall....',item)
    if (item && state.inCallList.length == 0) {
      if(item.incomingInviteRequest && item.incomingInviteRequest.message.headers.Tnumber && item.incomingInviteRequest.message.headers.Tnumber.length && item.incomingInviteRequest.message.headers.Tnumber[0].raw) {
        state.Tnumber = vueUtils.asteriskHeaderArray2Json(item.incomingInviteRequest.message.headers.Tnumber[0].raw).tnum
      }
    }
  },
  acceptedTheCall(context,item){
    console.log('acceptedTheCall item.....',item)
    context.commit('setCurrentCallerNum', item.data.line)
    if(checkIfSupportCall(item.data.line, state.Tnumber.trimStart())) {
      localStorage.setItem('callType', '2');
      callAnswered(item,(issueId)=>{
          state.redmineIssueId = issueId
          updateCurrentCallerInfo()
      })
    }
  },
  updateBuddies: (context, buddies) => {
    if(buddies && buddies.length){
      buddies.sort((a, b) => {
        if(a.LastActivity && b.LastActivity) {
          return moment(a.LastActivity.replace(" UTC", "")).diff(moment(b.LastActivity.replace(" UTC", "")), 'seconds' ) > 0 ? -1 : 1
        }
        if(a.lastActivity && b.lastActivity) {
          return moment(a.lastActivity.replace(" UTC", "")).diff(moment(b.lastActivity.replace(" UTC", "")), 'seconds' ) > 0 ? -1 : 1
        }
      })
      context.commit('updateBuddies', buddies)
    }
  },
  setOnCallInfo: (context, telNum) => {
    console.log('t === = = = == elNum',telNum);
    if(telNum){
      getOnCallInfo(telNum,(info)=>{
        state.onCallInfo = info
      })
    } else {
      state.onCallInfo = {}
    }
  }
}

const mutations = {
  setShowPhone: (state, status) =>{
    state.showPhone = status
  },
  updateLineList(state, lineList) {
    state.lineList = lineList;
    if(lineList.length>0){
      Vue.set(state.lineList, 0, state.lineList[0]);
      setCallListBystatus()
    }else{
      state.inCallList = []
      state.waitingList = []
      state.callList = []
    }
  },
  setCurrentCallerNum: (state, callerNum) =>{
    state.currentCallerNum = callerNum
  },
  setAutoStartMonitoringCall: (state, value) =>{
    state.autoStartMonitoringCall = value
  },
  updateBuddies: (state, buddies) => {
    state.buddiesList = buddies
  },
  setRegisterStatus:(state, status) => {
    state.registerStatus = status
  },
  setRedmineIssueId:(state, issueId) =>{
    state.redmineIssueId = issueId
  },
  setLongTimeWaiting:(state, time) =>{
    state.LONG_TIME_WAITING = time
  },
  updateCallStartAudioTime:(state, time)=>{
    state.CALL_START_AUDIO_TIME = time
  },
  updateShowStopMonitoringConfirmDialog: (state, stopMonitoringConfirmResult) => {
    state.showStopMonitoringConfirmDialog = stopMonitoringConfirmResult.showStopMonitoringConfirmDialog;
    if (stopMonitoringConfirmResult.stopMonitoring) {
      state.stopMonitoring = stopMonitoringConfirmResult.stopMonitoring;
    }
  },
  updateStopMonitoringTrigger: (state, stopMonitoringTrigger) => {
    state.stopMonitoringTrigger = stopMonitoringTrigger;
  },
  updateLineNumber: (state, lineNumber) => {
    state.lineNumber = lineNumber;
  },
  updateTNumber: (state, tNumber) => {
    state.tNumber = tNumber;
  },
  setMonitorInfo: (state, monitorInfo) => {
    Object.assign(state.monitorInfo, monitorInfo);
    if(monitorInfo.operatorName === 'AI VOICEBOT'){
      state.monitorInfo.operatorLogo = AI_VOICEBOT_LOGO
      state.monitorInfo.operatorEmail ='' 
    }
  },
  setMonitorInfoEmpty: (state) => {
    state.monitorInfo = getDefaultMonitorInfo()
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
